import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';

export type StringNullUndefined = string | null | undefined;

@Component({
  selector: 'planone-item-teaser-card',
  templateUrl: './item-teaser-card.component.html',
  styleUrls: ['./item-teaser-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemTeaserCardComponent implements AfterViewInit {
  @Input()
  cardTitle: string | undefined;

  @Input()
  url: StringNullUndefined[] | StringNullUndefined;

  @Input()
  showSubtitleArea: boolean | undefined;

  @Input()
  imageUrl: string | undefined;

  @Input()
  imagePlaceholder: string | undefined;

  @Input()
  imagePlaceholderIcon: string | undefined;

  @Input()
  imagePlaceholderFullsize: boolean | undefined;

  @Input()
  backgroundImage: string | undefined;

  @Input()
  highlight: boolean | undefined;

  @Input()
  topOfTheList: boolean | undefined;

  @Input()
  startup: boolean | undefined;

  @Input()
  markAsNew: boolean | undefined;

  @ViewChild('startupFlag', { read: ElementRef }) startupFlag: ElementRef | null | undefined;

  hideStartupText = false;

  ngAfterViewInit(): void {
    this.detectFlexWrap();
  }

  @HostListener('window:resize')
  resized() {
    this.detectFlexWrap();
  }

  private detectFlexWrap() {
    if (!this.startupFlag?.nativeElement) {
      return;
    }

    const wrappedItems: Element[] = [];
    let prevItem: DOMRect | undefined = undefined;
    let currItem: DOMRect | undefined = undefined;

    if (typeof this.startupFlag.nativeElement.children[Symbol.iterator] === 'function') {
      for (const child of this.startupFlag.nativeElement.children as Element[]) {
        currItem = child.getBoundingClientRect();

        if (prevItem && prevItem.top + 25 < currItem.top) {
          wrappedItems.push(child);
        }

        prevItem = currItem;
      }
    }

    this.hideStartupText = wrappedItems.length > 0;
  }
}
